let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dnzTt")).then(() => parcelRequire('krf2j'));